import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Products = () => {
    const [products, setProducts] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const [loading, setLoading] = useState(true);

    const BASE_URL = window.location.hostname === 'localhost'
        ? 'http://127.0.0.1:8003'
        : 'https://rbmchemicals.com';

    useEffect(() => {
        fetch(`${BASE_URL}/api/get_products/`)
            .then((res) => res.json())
            .then((data) => {
                setProducts(Array.isArray(data) ? data : []);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching products:", err);
                setLoading(false);
            });
    }, [BASE_URL]);

    const displayProducts = showAll ? products : products.slice(0, 3);

    if (loading) return <div className="text-center py-20">Loading Products...</div>;

    return (
        <section className="py-16 bg-gray-50">
            <div className="container mx-auto px-10">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 text-gray-800">
                    Product Collection
                </h2>

                {products.length === 0 ? (
                    <p className="text-center text-gray-500">No products available at the moment.</p>
                ) : (
                    <>
                        <motion.div
                            key={showAll ? "all" : "limited"}
                            className="grid grid-cols-1 md:grid-cols-3 gap-8"
                            initial="hidden"
                            animate="visible"
                            variants={{
                                hidden: { opacity: 0 },
                                visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
                            }}
                        >
                            {displayProducts.map((item) => (
                                <motion.div
                                    key={item.id}
                                    variants={{
                                        hidden: { opacity: 0, scale: 0.8 },
                                        visible: { opacity: 1, scale: 1 }
                                    }}
                                    className="bg-white shadow-lg border p-4 rounded-lg flex flex-col justify-between"
                                >
                                    <div>
                                        <img
                                            src={item.image && item.image.startsWith('http') ? item.image : `${BASE_URL}${item.image}`}
                                            alt={item.title || "Product"}
                                            className="w-full h-64 object-cover rounded"
                                            onError={(e) => { e.target.src = 'https://via.placeholder.com/400'; }}
                                        />
                                        <h3 className="text-2xl font-semibold mt-4 text-gray-800">{item.title}</h3>
                                    </div>

                                    <Link
                                        to={`/product/${item.id}`}
                                        onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
                                        className="mt-6"
                                    >
                                        <button className="w-full bg-[#002b5b] text-white px-6 py-2 rounded hover:bg-orange-500 transition">
                                            Explore More
                                        </button>
                                    </Link>
                                </motion.div>
                            ))}
                        </motion.div>

                        {products.length > 3 && (
                            <div className="text-center mt-12">
                                <button
                                    onClick={() => setShowAll(!showAll)}
                                    className="bg-gray-800 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-black transition duration-300"
                                >
                                    {showAll ? "Show Less" : "View All Products"}
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </section>
    );
};

export default Products;